import React from 'react';
import Tabs from 'components/layout/Tabs/Tabs';

export default function ReminderTabs() {
  const tabs = [
    { name: 'All reminders', href: '/reminders' },
    { name: 'Create reminder', href: '/reminders/add' },
    { name: 'Logs', href: '/reminders/logs' },
  ];

  return <Tabs tabs={tabs} />;
}